
import { defineComponent, PropType } from '@vue/runtime-core'
import Checklist from '@/components/block/Checklist.vue'
import SeminarCassette from '@/components/block/SeminarCassette.vue'
import { WpImage } from '@/types/WpRestApi'

interface Benefit {
  title: string
  description: string
  image: WpImage | false
  label_icon: string
}

export default defineComponent({
  name: 'EventDetailBenefits',

  components: {
    Checklist,
    SeminarCassette
  },

  props: {
    benefits: {
      type: Array as PropType<Benefit[]>,
      default: () => []
    }
  }
})
